import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import VueMask from "v-mask";
import VeeValidate from "vee-validate";
import Promise from "es6-promise";
import VueAnalytics from "vue-analytics";
import VTooltip from 'v-tooltip';
import VModal from "vue-js-modal";

Vue.use(VTooltip)
Vue.use(VModal);

Promise.polyfill();

Vue.config.API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;
Vue.config.HOST_URL = process.env.VUE_APP_HOST_URL;
Vue.config.productionTip = false;
Vue.use(VueMask);
Vue.use(VeeValidate);
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GA_KEY,
  router,
  autoTracking: {
    pageviewOnLoad: false
  }
});

var instance = axios.create({
  baseURL: Vue.config.API_ENDPOINT,
  timeout: 30000,
  headers: { "X-Custom-Header": "Essilor Sampling" }
});

window.axios = instance;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");